import Button from '@material-ui/core/Button'
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import WebFooter from '../../source/WebScreen/WebFooter'
import styles from './LoginForm.module.css'
import { getQueryParams } from '../authentication/utils'

export class SignIn extends Component {
  constructor(props) {
    super(props)
    this.emailInput = React.createRef()
    this.passwordInput = React.createRef()

    this.state = {
      username: '',
      password: '',
      errorflag: false,
      errorshow: false,
      isReveal: true
    }
  }

  componentDidMount() {
    this.loadQueryParams()
  }

  loadQueryParams = () => {
    let queryParams = getQueryParams()

    if (queryParams.u && queryParams.p) {
      let userName = decodeURI(queryParams.u)
      let password = decodeURI(queryParams.p)
      this.emailInput.current.value = userName
      this.passwordInput.current.value = password

      let usernameObj = {
        target: {
          name: 'username',
          value: userName
        }
      }
      this.props.handleChange(usernameObj)

      let passwordObj = {
        target: {
          name: 'password',
          value: password
        }
      }
      this.props.handleChange(passwordObj)
    }
  }

  handleSubmit = event => {
    this.props.handleSubmit(event)
  }

  handleChange = event => {
    this.props.handleChange(event)
  }
  handleForgot = event => {
    console.log('inside handle logout')
    this.props.handleForgot(event)
  }
  gotoCheckRegistration = event => {
    this.props.gotoCheckRegistration()
  }
  togglePassword = id => {
    this.setState({ isReveal: !this.state.isReveal })
    var pass = document.getElementById(id)
    if (pass.type == 'password') {
      pass.type = 'text'
    } else {
      pass.type = 'password'
    }
  }

  handleKeyUp(e) {
    if (e.keyCode == 9) {
      e.preventDefault()
          }
  }

  render() {
    return (
      <div className="loginformnew">
        {!this.props.isNative && (
          <div className={styles.loginform_flex_container}>
            {/* Left Panel: Image and Footer */}
            <div className={styles.loginform_left_panel}>
              <div className={styles.loginform_image_wrapper}>
                <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} className={styles.loginform_main_image} alt="welcome" />
              </div>
              <div className={styles.loginform_footer}>
                Copyright © 2019-2026 Universal Health Fellowship. All rights reserved. | Powered by CarynHealth<br />
                Version 6.1.0
              </div>
            </div>
            {/* Right Panel: Form */}
            <div className={styles.loginform_right_panel}>
              <form onSubmit={this.handleSubmit.bind(this)} className={styles.loginform_form_wrapper}>
                <img src={require('../../source/Images/Banner/logo.png')} className={styles.login_uhs_logo} alt="logo" />
                <div className={styles.login_input_container}>
                  <input
                    type="text"
                    ref={this.emailInput}
                    placeholder="Enter your email"
                    style={{fontSize:'20px'}}
                    name="username"
                    required
                    onChange={this.handleChange}
                    className={["login_input_username", styles.loginform_input].join(' ')}
                  />
                  <div className={styles.loginform_password_wrapper}>
                    <input
                      className={["login_input_username", styles.loginform_input].join(' ')}
                      id="pass"
                      type="password"
                      placeholder="Enter your password"
                      style={{fontSize:'20px'}}
                      name="password"
                      ref={this.passwordInput}
                      required
                      onChange={this.handleChange.bind(this)}
                      onKeyDown={this.handleKeyUp}
                    />
                    <span className={["p-viewer", styles.loginform_eye_icon].join(' ')} onClick={() => this.togglePassword('pass')}>
                      {this.state.isReveal ? (
                        <i className="fa fa-eye-slash" aria-hidden="true"></i>
                      ) : (
                        <i className="fa fa-eye" aria-hidden="true"></i>
                      )}
                    </span>
                  </div>
                  {this.props.errorMsg && this.props.errorMsg.length > 0 && (
                    <div className={styles.login_error_message}>{this.props.errorMsg}</div>
                  )}
                  <div className={styles.loginform_forgot_wrapper}>
                    <span className="loginmobile_forgot_text" onClick={this.handleForgot.bind(this)}>
                      Forgot your password?
                    </span>
                  </div>
                  <Button type="submit" className={["login_button", styles.loginform_button].join(' ')} disabled={this.props.disableSiginBtn}>
                    SIGN IN
                  </Button>
                </div>
                <div className={styles.login_bottom_text}>
                  <div className={styles.login_bottom_subtext}>Having trouble logging in?</div>
                  <div className={styles.login_bottom_subtext}>
                    <Link to="/check-registration">
                      <span className={styles.login_plese_text}>Please check</span>
                    </Link>
                    &nbsp;if your email has been registered <br></br> on the portal.
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    )
  }
}
export default SignIn
